export default file => () => import('@/pages/' + file + '.vue');
// export default (file: string) => require('@/pages/' + file + '.vue').default;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/import/production.ts